module.exports = __webpack_public_path__ + "static/media/AimGuideImage.c662905a.png";